import { render, staticRenderFns } from "./FaltantesCerradosTable.vue?vue&type=template&id=27101cee"
import script from "./FaltantesCerradosTable.vue?vue&type=script&lang=js"
export * from "./FaltantesCerradosTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports